import axios from 'axios';
import { Quota } from '../models/common-types';
import { getQueryStringFromParams } from '../utils/communication';

export interface QuotaApi {
    fetchQuota(quotaType?: string): Promise<Quota>;
    fetchQuotaValid(wsId: number, quotaType?: string): Promise<Quota>;
}

const baseUrl = '/api/osint/quota/';

export class QuotaAPI implements QuotaApi {
    async fetchQuota(quotaType?: string) {
        const finalQuotaType = quotaType || 'Search';
        const params = [];
        params.push({ key: 'quotaType', value: finalQuotaType });
        const queryString = getQueryStringFromParams(params);
        try {
            const response = await axios.get(`${baseUrl}env/usage${queryString}`);
            return response.data;
        } catch (error) {
            throw new Error('Quota request failed');
        }
    }

    async fetchQuotaValid(wsId: number, quotaType?: string) {
        const finalQuotaType = quotaType || 'Search';
        const params = [];
        params.push({ key: 'workspace', value: wsId });
        params.push({ key: 'quotaType', value: finalQuotaType });
        const queryString = getQueryStringFromParams(params);
        try {
            const response = await axios.get(`${baseUrl}valid${queryString}`);
            return response.data;
        } catch (error) {
            throw new Error('Quota is not valid');
        }
    }
}
